/* eslint-disable react/no-did-update-set-state */
import React from 'react';
import { trans } from '../../../../../localization/index';
import Modal, {
  ModalAction,
  ModalBody,
  ModalButton,
  ModalHeader,
} from '../../../../../components/Modal/Modal';
import InputWrapper from '../../../../../components/Common/InputWrapper';
import './style.scss';

class TableMerchantNoteModal extends React.Component {
  state = {
    merchantNote: this.props.order ? this.props.order.merchant_note : '',
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.order && this.props.order) {
      this.setState({
        merchantNote: this.props.order.merchant_note,
      })
    }
  }

  onChange = event => {
    this.setState({
      merchantNote: event.target.value,
    });
  };

  onSubmitClick = () => {
    const { merchantNote } = this.state;
    this.props.submitMerchantNote({
      merchant_note: merchantNote,
    });
  };

  render() {
    const { isOpenDialog, onClose } = this.props;
    return (
      <Modal isOpen={isOpenDialog} width="400px" className="merchant-note-order reject-order">
        <ModalHeader>{trans('configure_order_merchant_note')}</ModalHeader>
        <ModalBody className="padding-0">
          <InputWrapper>
            <textarea
              name="Text1"
              cols="50"
              rows="5"
              style={{ marginTop: '10px' }}
              placeholder={trans('type_merchant_note')}
              value={this.state.merchantNote}
              onChange={this.onChange}
            />
          </InputWrapper>
        </ModalBody>
        <ModalAction>
          <ModalButton type="cancel" onClick={onClose}>
            {trans('mod_go_back')}
          </ModalButton>
          <ModalButton onClick={this.onSubmitClick}>
            {trans('send')}
          </ModalButton>
        </ModalAction>
      </Modal>
    );
  }
}

export default TableMerchantNoteModal;



// WEBPACK FOOTER //
// ./foody/src/pages/Table/TableManagement/components/TableReportOrderModal/TableMerchantNoteModal.jsx